import React, { useCallback, useEffect, useState } from "react";
import { MODULE_API } from "../../../../apis";
import * as Style from "../inventory/styles/inventory";
import asset from "../../../../assets/images/asset.png";
import tableimg from "../../../../assets/images/big/camera.png";
import Loader from "../../../styled-components/loader/loader";
import { Modal, Form, Button, Icon } from "antd";
import PropertyAdd from "./property/property-add";
import RoomAdd from "./Room/room-add";
import PropertyUpdate from "./property/property-update";
import swal from "sweetalert";
import RoomUpdate from "./Room/room-update";
import { Link, useHistory } from "react-router-dom";
import { defaultStyles } from "../../../../constants/style-constants/utils";
// import addIcon from "../../../../assets/SVGs/android-chrome-512x512.png";
import addIcon from "../../../../assets/images/DeathModuleNew/addIcon.png";
import { BorrowItemModal } from "./modals/BorrowItemModal";
import { LoanItemModal } from "./modals/LoanItemModal";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  saveActiveProperty,
  saveAllProperties,
} from "../../../../redux/slices/propertiesSlice";
import {
  saveActiveRoom,
  saveAllRooms,
} from "../../../../redux/slices/roomsSlice";
import {
  saveAllItems,
  saveActiveItem,
} from "../../../../redux/slices/itemsSlice";
import moment from "moment";

function inventory(props) {
  const { colors } = defaultStyles;
  const [allProperties, setAllProperties] = useState([]);
  const [activeItem, setActiveItem] = useState("");
  const [totalValues, setTotalValues] = useState(0);
  const [detailsModal, setDetailsModal] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);

  const [activeRoom, setActiveRoom] = useState();
  const [allRooms, setAllRooms] = useState([]);
  const [allItems, setAllItems] = useState([]);
  const [allHeading, setHeading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isModal, setModal] = useState(false);
  const [showItems, setShowItems] = useState(false);
  const [showPropertyAdd, setShowPropertyAdd] = useState(false);
  const [showRoomAdd, setShowRoomAdd] = useState(false);
  const [showItemAdd, setShowItemAdd] = useState(false);
  const [parentId, setParentId] = useState();
  const [roomId, setRoomId] = useState();
  const history = useHistory();
  const [data, setData] = useState(false);
  const [updateProperty, setUpdateProperty] = useState({});
  const [showUpdateProperty, setShowUpdateProperty] = useState(false);
  const [updateRoom, setUpdateRoom] = useState({});
  const [showUpdateRoom, setShowUpdateRoom] = useState(false);
  const [updateItem, setUpdateItem] = useState({});
  const [showUpdateItem, setShowUpdateItem] = useState(false);
  const [editItemDetails, setEditItemDetails] = useState({});
  const { propertiesInfo, roomsInfo, itemsInfo } = useSelector(
    (state) => state.rootReducer
  );

  const [addLoanModal, setAddLoanModal] = useState(false);
  const [addBorrowModal, setAddBorrowModal] = useState(false);
  const [formDataLoan, setFormDataLoan] = useState(null);
  const [formDataBorrow, setFormDataBorrow] = useState(null);

  const handleInputChangeLoan = (name, value) => {
    setFormDataLoan({
      ...formDataLoan,
      [name]: value,
    });
  };
  const handleInputChangeBorrow = (name, value) => {
    setFormDataBorrow({
      ...formDataBorrow,
      [name]: value,
    });
  };
  const handleCancelAddLoanModal = () => {
    setAddLoanModal(false);
    setFormDataLoan(null);
  };
  const handleCancelAddBorrowModal = () => {
    setAddBorrowModal(false);
    setFormDataBorrow(null);
  };

  const handleSaveAddLoanModal = async () => {
    setAddLoanModal(false);
    try {
      const fetchroomInfo =
        roomsInfo && roomsInfo.allrooms
          ? roomsInfo.allrooms.find(
              (room) =>
                room.id === (roomsInfo.activeRoom && roomsInfo.activeRoom.id)
            )
          : null;
      let payload = {
        ...formDataLoan,
        roomId: roomId && roomId.id || (fetchroomInfo && fetchroomInfo.id),
        propertyId: parentId ? parentId.id : activeItem.id,
      };
      console.log("formDataLoan", payload);
      setIsLoading(true);
      let data = await MODULE_API.loanItemCreate(payload);
      if (data && data.status === 200) {
        swal("Success", data.message, "success");
         if(roomId){
          await fetchItem(roomId)
        }
        // await getCarryForward();
      }
      if (data && data.status === 400) {
        swal("Oops!", data.message, "error");
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }

    setFormDataLoan(null);
  };
  const handleReturnItem = async (itemId) => {
    setAddBorrowModal(false);
    try {
      const fetchroomInfo =
        roomsInfo && roomsInfo.allrooms
          ? roomsInfo.allrooms.find(
              (room) =>
                room.id === (roomsInfo.activeRoom && roomsInfo.activeRoom.id)
            )
          : null;
      let payload = {
        // ...formDataBorrow,
        itemId:itemId
        // roomId: roomId && roomId.id || (fetchroomInfo && fetchroomInfo.id),
        // propertyId: parentId ? parentId.id : activeItem.id,
      };
      console.log("formDataBorrow", payload);
      setIsLoading(true);
      let data = await MODULE_API.loanItemUpdate(itemId,payload);
      if (data && data.status === 200) {
        swal("Success", data.message, "success");
        if(roomId){
          await fetchItem(roomId)
        }
        // await getCarryForward();
      }
      if (data && data.status === 400) {
        swal("Oops!", data.message, "error");
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }

    setFormDataBorrow(null);
  };
  const handleSaveAddBorrowModal = async () => {
    setAddBorrowModal(false);
    try {
      const fetchroomInfo =
        roomsInfo && roomsInfo.allrooms
          ? roomsInfo.allrooms.find(
              (room) =>
                room.id === (roomsInfo.activeRoom && roomsInfo.activeRoom.id)
            )
          : null;
      let payload = {
        ...formDataBorrow,
        roomId: roomId && roomId.id || (fetchroomInfo && fetchroomInfo.id),
        propertyId: parentId ? parentId.id : activeItem.id,
      };
      console.log("formDataBorrow", payload);
      setIsLoading(true);
      let data = await MODULE_API.borrowItemCreate(payload);
      if (data && data.status === 200) {
        swal("Success", data.message, "success");
        // await getCarryForward();
      }
      if (data && data.status === 400) {
        swal("Oops!", data.message, "error");
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }

    setFormDataBorrow(null);
  };

  useEffect(() => {
    if (propertiesInfo.activeProperty.id) {
      setActiveItem(
        propertiesInfo &&
          propertiesInfo.allProperties &&
          propertiesInfo.allProperties.find(
            (item) => item.id === propertiesInfo.activeProperty.id
          )
      );
    }
    console.log("active item", propertiesInfo.activeProperty);
  }, [propertiesInfo]);
  const dispatch = useDispatch();
  const updateInventory = useCallback((item) => {
    fetchRoom(item);
    handleModalCancel();
  }, []);
  const updateProperties = useCallback(() => {
    setAllProperties([]);
    inventoryReport();
    console.log("add properites");
    handleModalCancel();
  }, []);

  React.useEffect(() => {
    inventoryReport();
  }, []);
  // useEffect(()=>{
  //   if(allRooms && allRooms.length>0){
  //     fetchItem(allRooms[0])
  //   }
  // },[])

  const getSelectedRecords = async (record, name) => {
    setDetailsModal(true);
    console.log("record to edit", record);
    if (name === "Images") {
      setCurrentRecord({
        files: record.multiImg ? record.multiImg : [],
        name: name,
      });
    } else {
      setCurrentRecord({
        files: record.videos ? record.videos : [],
        name: name,
      });
    }
  };
  const handleCancel = () => {
    setCurrentRecord(null);
    setDetailsModal(false);
  };

  let propertiesList = [];
  let roomsList = [];
  let rooms = [];
  const styles = {
    hidescroll: {
      width: "100%",
      overflow: "hidden",
    },
    container: {
      width: "100%",
      overflowX: "auto",
      paddingBottom: 20,
      marginBottom: -20,
    },
  };

  async function addProperty() {
    setShowPropertyAdd(true);
    setModal(true);
  }

  async function addRoom() {
    setShowRoomAdd(true);
    setModal(true);
  }

  async function addItem() {
    setShowItemAdd(true);
    const fetchroomInfo =
      roomsInfo && roomsInfo.allrooms
        ? roomsInfo.allrooms.find(
            (room) =>
              room.id === (roomsInfo.activeRoom && roomsInfo.activeRoom.id)
          )
        : null;
    history.push(
      `/add_item/${parentId ? parentId.id : activeItem.id}/${
        roomId ? roomId.id : fetchroomInfo.id
      }`,
      { property: { ...parentId, room: roomId } }
    );
  }

  async function fetchItem(itemsList) {
    console.log("fetchItem", itemsList);
    setRoomId(itemsList);
    setActiveRoom(itemsList.id);
    setIsLoading(true);
    let item = await MODULE_API.fetchRooms({
      id: itemsList.id,
      body: {},
    });
    // console.log("rooms listing", item);
    setIsLoading(false);
    if (item.data && item.data.children && item.data.children.length === 0) {
      setData(true);
    } else {
      setData(false);
    }
    item =
      item.data &&
      item.data.children &&
      item.data.children.map((items) => ({
        id: items.id,
        room: item.data ? item.data.name : "N/A",
        name: items.name ? items.name : "N/A",
        quantity: items.quantity ? items.quantity : "N/A",
        value: item.data ? item.data.total : 0,
        currentValue: items.currentValue,
        isLoan:items.isLoan,
        img: items.images && items.images[0] ? items.images[0] : tableimg,
      }));
      console.log("iteeeeee",item)
    setAllItems(item);
    setShowItems(true);
    // console.log("items listing", item);
    // setTimeout(() => {
    //   getAllItems(itemsList.id);
    // }, 500);
    dispatch(saveActiveRoom({ id: itemsList.id, children: item }));
    dispatch(saveAllItems(item));
  }

  async function fetchRoom(item) {
    setAllItems([]);
    setParentId(item);
    setActiveItem(item);
    setIsLoading(true);
    let roomsData = await MODULE_API.fetchRooms({
      id: item.id,
      body: {},
    });

    setIsLoading(false);
    // console.log("active", activeItem);
    // console.log("roomsData", roomsData);
    // roomsList =
    //   room.data &&
    //   room.data.map((property) => ({
    //     propertyName: property.name,
    //     room: rooms,
    //   }));
    rooms =
      roomsData &&
      roomsData.data &&
      roomsData.data.children &&
      roomsData.data.children.map((room) => ({
        id: room.id,
        room: room ? room.name : "N/A",
        name: room.name ? room.name : "N/A",
        value: room.total ? room.total : 0,
        images: room.images ? room.images : [],
        detail: room.detail ? room.detail : "",
        img: room.images && room.images[0] ? room.images[0] : tableimg,
        videos: room.videos ? room.videos : [],
      }));
    // console.log("rooms", rooms);
    setAllRooms(rooms);
    setHeading(true);

    dispatch(
      saveActiveProperty({
        id: item.id,
        children: roomsData && roomsData.data.children,
      })
    );
    dispatch(saveAllRooms(rooms));
  }

  async function inventoryReport() {
    if (
      (propertiesInfo &&
        propertiesInfo.allProperties &&
        propertiesInfo.allProperties.length === 0) ||
      (allProperties && allProperties.length === 0)
    ) {
      console.log("propertiesInfo", propertiesInfo);
      setIsLoading(true);
      setAllProperties([]);
      let inventories = await MODULE_API.fetchItems({
        moduleName: "PROPERTY",
        pageNum: 1,
        limit: 100,
        body: {},
      });
      setIsLoading(false);
      // console.log("new report", inventories.records);
      // console.log("inventories", inventories);
      propertiesList =
        inventories &&
        inventories.records &&
        inventories.records.map((properties) => ({
          id: properties.id,
          name: properties.name,
          total: properties.total ? properties.total : 0,
          img:
            properties.images && properties.images[0]
              ? properties.images[0]
              : tableimg,
          // description:
          //   "Lorem Ipsum Lorem Ipsum Lorem Ipsum, Lorem Ipsum Lorem Ipsum Lorem Ipsum",
          // setTotalValues(...totalValues + properties.total),
          // setTotalValues((totalValues) => totalValues + total)
          city: properties.city ? properties.city : "N/A",
          state: properties.state ? properties.state : "N/A",
          zip: properties.zip ? properties.zip : " N/A",
          type: properties.type,
          street: properties.street ? properties.street : "N/A",
          multiImg: properties.images,
          videos: properties.videos ? properties.videos : [],
        }));
      propertiesList &&
        propertiesList.map(
          (properties) => console.log("properties", properties.total)
          // setTotalValues((prev) => prev + properties.total)
        );
      const initialValue = 0;
      const sumWithInitial =
        propertiesList &&
        propertiesList.reduce(
          (accumulator, currentValue) => accumulator + currentValue.total,
          initialValue
        );
      console.log("sumWithInitial", sumWithInitial);
      setTotalValues(sumWithInitial);
      setAllProperties(propertiesList);
      dispatch(saveAllProperties(propertiesList));
    }
  }
  useEffect(() => {
    setAllProperties(propertiesInfo.allProperties);
  }, [propertiesInfo]);
  useEffect(() => {
    if (roomsInfo && roomsInfo.allrooms && roomsInfo.allrooms.length > 0) {
      setHeading(true);
      setAllRooms(roomsInfo.allrooms);
    }
  }, [roomsInfo]);
  useEffect(() => {
    if (itemsInfo && itemsInfo.allItems && itemsInfo.allItems.length > 0) {
      setAllItems(itemsInfo.allItems);
      setShowItems(true);
    }
  }, [itemsInfo]);

  async function handleModalCancel() {
    setShowPropertyAdd(false);
    setShowRoomAdd(false);
    setShowItemAdd(false);
    setShowUpdateProperty(false);
    setShowUpdateRoom(false);
    setShowUpdateItem(false);
    setModal(false);
  }
  function handleDelete(event, item, type) {
    swal({
      title: "Are you sure?",
      text: "Are you sure that you want to Delete this Property?",
      icon: "warning",
      dangerMode: true,
      buttons: true,
    }).then(async (doDelete) => {
      setIsLoading(true);
      doDelete &&
        (await MODULE_API.removeClientModule({
          clientModules: [item.id],
        }));
      if (type == "property") {
        updateProperties();
        setActiveItem("");
        setAllRooms("");
        inventoryReport();
        return;
      } else if (type == "room") {
        if (activeItem.id) {
          await MODULE_API.getRecordTotal(activeItem.id, {
            attributes: ["total"],
          });
        }
        setAllItems("");
        setShowItems(false);
        setShowItemAdd(false);
      } else {
        await MODULE_API.getRecordTotal(activeRoom, {
          attributes: ["currentValue"],
        });
        await MODULE_API.getRecordTotal(activeItem.id, {
          attributes: ["total"],
        });
      }
      updateInventory(activeItem);
    });
  }

  function handleEditProperty(e, item) {
    setModal(true);
    setShowUpdateProperty(true);
    // console.log("event", e, "item", item);
    setUpdateProperty(item);
  }

  function handleEditRoom(e, item) {
    setModal(true);
    setShowUpdateRoom(true);
    console.log("event", e, "item", item);
    setUpdateRoom(item);
  }
  function handleViewRoom(e, item) {
    setModal(true);
    setShowUpdateRoom(true);
    console.log("event", e, "item", item);
    setUpdateRoom({ ...item, edit: true });
  }
  // const detaiRoom = () =>{
  //   <Detail/>
  // }
  async function handleEditItem(e, item) {
    const fetchroomInfo =
      roomsInfo && roomsInfo.allrooms
        ? roomsInfo.allrooms.find(
            (room) =>
              room.id === (roomsInfo.activeRoom && roomsInfo.activeRoom.id)
          )
        : null;
    console.log("room id is", fetchroomInfo, activeItem, parentId);
    updateInventory(activeItem);
    setUpdateItem(item);
    setIsLoading(true);
    let itemDetails = await MODULE_API.fetchRooms({
      id: item.id,
      body: {},
    });
    setIsLoading(false);
    setEditItemDetails(itemDetails);
    const bodyyy = {
      property: {
        ...(parentId ? parentId : activeItem),
        room: roomId ? roomId : fetchroomInfo.id,
      },
      data: { ...item },
      isUpdate: true,
      editItem: { ...itemDetails },
    };
    if (updateItem && editItemDetails) {
      setTimeout(() => {
        history.push(
          `/update_item/${item.id}/${parentId ? parentId.id : activeItem.id}/${
            roomId ? roomId.id : fetchroomInfo.id
          }`,
          bodyyy
        );
      }, 200);
    }
  }

  async function getAllItems(roomID) {
    await MODULE_API.fetchItems({
      moduleName: `ITEM`,
      pageNum: 1,
      limit: 10,
      body: {
        parentId: roomID,
      },
    });
  }

  const handleModalButton = () => {
    setModal(false);
    setShowPropertyAdd(false);
    setShowRoomAdd(false);
    setShowItemAdd(false);
    setShowUpdateItem(false);
    setShowUpdateProperty(false);
    setShowUpdateRoom(false);
  };
  const handleRoomModalButton = () => {
    setShowRoomAdd(!showRoomAdd);
  };

  function moneyFormatter(value) {
    // Create our number formatter.
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    });

    let result = formatter.format(value);
    // console.log("Money :: ", result);
    return result;
  }
  return (
    <div>
      <Style.Main>
        {/* <Style.SubMain>
          <div>
            <h3 style={{ fontWeight: "bold" }}>Inventory Report</h3>
          </div>
          <Style.Container>
            <Style.Heading>
              <Style.Subheading>
                <Style.Headingh4>All Inventory</Style.Headingh4>
              </Style.Subheading>
              <Style.Image>
                <span>
                  <img src={asset} style={{ width: "5rem" }} />
                </span>
              </Style.Image>
            </Style.Heading>
            <Style.SubContainer>
              <Style.Title
              //  style={{ width: "10rem" }}
              >
                <Style.Text alignCenter={true}>Client Name</Style.Text>
              </Style.Title>
              <Style.Data>
                <Style.Text alignCenter={true}>{localStorage.getItem("User") ? localStorage.getItem("User") : <React.Fragment></React.Fragment>}</Style.Text>
              </Style.Data>
            </Style.SubContainer>
            <Style.SubContainer>
              <Style.Title
              //  style={{ width: "10rem" }}
              >
                <Style.Text alignCenter={true}>Todays Date</Style.Text>
              </Style.Title>
              <Style.Data>
                <Style.Text alignCenter={true}>{moment().format("MM/DD/YYYY")}</Style.Text>
              </Style.Data>
            </Style.SubContainer>
          </Style.Container>
          <Style.Container>
            <Style.Heading>
              <Style.Count>
                <div style={{ width: "100%", display: "flex" }}>
                  <Style.Sign>
                    <Style.Headingh4
                      style={{
                        color: "white",
                        padding: "0.5rem ",
                        margin: "auto",
                      }}
                    >
                      {"    $    "}
                    </Style.Headingh4>
                  </Style.Sign>
                  <div
                    style={{
                      width: "90%",
                      display: "flex",
                      justifyContent: "center",
                      paddingRight: "1rem",
                    }}
                  >
                    <Style.Text
                      alignCenter={true}
                      style={{
                        paddingTop: "0.7rem",
                        color: "#39b54a",
                        fontWeight: "bold",
                      }}
                    >
                      {totalValues && totalValues}
                    </Style.Text>
                  </div>
                </div>
              </Style.Count>
            </Style.Heading>
            <Style.SubContainer>
              <Style.Title style={{ width: "8rem" }}>
                <Style.Text alignCenter={true}>Spouse Name</Style.Text>
              </Style.Title>
              <Style.Data>
                <Style.Text alignCenter={true}>None</Style.Text>
              </Style.Data>
            </Style.SubContainer>
            <Style.SubContainer>
              <Style.Title style={{ width: "8rem" }}>
                <Style.Text alignCenter={true} style={{ textAlign: "justify" }}>
                  Plan Nickname
                </Style.Text>
              </Style.Title>
              <Style.Data>
                <Style.Text alignCenter={true}>None</Style.Text>
              </Style.Data>
            </Style.SubContainer>
          </Style.Container>
        </Style.SubMain> */}

        <Style.Cards>
          <Style.SubCards
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Style.CardsHead>
              <h3 style={{ fontWeight: "bold" }}>Properties</h3>
            </Style.CardsHead>
            <Style.PropertyAdd
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "1rem",
                width: "",
              }}
            >
              <div>
                <h3>Add Property</h3>
              </div>
              <div
                onClick={() => addProperty()}
                className="upload"
                style={{ width: "28px", height: "28px", cursor: "pointer" }}
              >
                <img
                  src={addIcon}
                  width={12}
                  height={12}
                  style={{ width: "16px", height: "16px" }}
                  alt="addicon"
                ></img>
              </div>
            </Style.PropertyAdd>
          </Style.SubCards>

          <Style.CardsMain
            style={{
              justifyContent:
                allProperties && allProperties.length > 0 ? "start" : "center",
              padding: "8px",
              gap: "1rem",
            }}
          >
            {allProperties ? (
              allProperties.map((item, index) => (
                <Style.Card
                  key={index}
                  onClick={() => fetchRoom(item)}
                  // style={{
                  //   // borderColor: activeItem !== item.id ? colors.green : "none",
                  // }}
                  active={item.id == activeItem}
                >
                  <div style={{ overflow: "hidden", padding: "1rem" }}>
                    <Style.Img src={item.img} />
                  </div>
                  <div style={{ overflow: "hidden", margin: "auto" }}>
                    <Button
                      type="link"
                      style={{ fontSize: "21px", color: "#2a3da3" }}
                      icon="file-image"
                      onClick={(e) => {
                        e.stopPropagation();
                        getSelectedRecords(item, "Images");
                      }}
                    ></Button>
                    <Button
                      type="link"
                      style={{ fontSize: "21px", color: "#2a3da3" }}
                      icon="video-camera"
                      onClick={(e) => {
                        e.stopPropagation();
                        getSelectedRecords(item, "Videos");
                      }}
                    ></Button>
                  </div>
                  <Style.PropertyCardDetails
                    style={{ padding: "0rem 0.5rem 0 1rem" }}
                  >
                    <div style={{ paddingTop: "1rem", overflow: "hidden" }}>
                      <Style.PropertyCardH3>{item.name}</Style.PropertyCardH3>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "1px",
                      }}
                    >
                      <div className="custom-field-alignments-icons">
                        <Button
                          type="link"
                          style={{ fontSize: "21px" }}
                          icon="edit"
                          onClick={(e) => {
                            handleEditProperty(e, item);
                            console.log("itemsssssssss", item);
                          }}
                        ></Button>
                      </div>
                      <Link
                        to={{
                          pathname: `/property-detail/${item.id}`,
                          query: `id=${item.id}`,
                          state: item,
                        }}
                      >
                        <div className="custom-field-alignments-icons">
                          <Button
                            type="link"
                            style={{
                              fontSize: "21px",
                              padding: "0px 6px",
                              margin: "0px",
                            }}
                            icon="eye"
                          ></Button>
                        </div>
                      </Link>

                      <div className="custom-field-alignments-icons">
                        <Button
                          type="link"
                          style={{ fontSize: "21px" }}
                          icon="delete"
                          onClick={(e) => {
                            handleDelete(e, item, "property");
                          }}
                        ></Button>
                      </div>
                    </div>
                  </Style.PropertyCardDetails>
                  {/* <Style.Desc>
                    <div style={{ display: "flex" }}>
                      <div>
                        <p>Street:</p>
                      </div>
                      <div>
                        <p
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            paddingLeft: "0.4rem",
                          }}>
                          {item.street}
                        </p>
                      </div>
                    </div>
                    <div style={{ display: "flex" }}>
                      <div>
                        <p>City:</p>
                      </div>
                      <div>
                        <p
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            paddingLeft: "0.4rem",
                          }}>
                          {item.city}
                        </p>
                      </div>
                    </div>
                    <div style={{ display: "flex", width: "90%" }}>
                      <div style={{ display: "flex", width: "100%" }}>
                        <div>
                          <p>State:</p>
                        </div>
                        <div>
                          <p
                            style={{
                              fontWeight: "bold",
                              color: "black",
                              paddingLeft: "0.4rem",
                            }}>
                            {item.state}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex", width: "100%" }}>
                        <div>
                          <p>Zip:</p>
                        </div>
                        <div>
                          <p
                            style={{
                              fontWeight: "bold",
                              color: "black",
                              paddingLeft: "0.4rem",
                            }}>
                            {item.zip}
                          </p>
                        </div>
                      </div>
                    </div>
                  </Style.Desc> */}
                  <Style.Desc
                    style={{
                      paddingInline: "1rem",
                      borderBottom: "1px solid #F0F0F0",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <div>
                          <p
                            style={{
                              fontFamily: "Poppins",
                              fontSize: "12px",
                              fontWeight: "400",
                              color: "#8B8D97",
                            }}
                          >
                            Account Type:
                          </p>
                        </div>
                        <div>
                          <p
                            style={{
                              fontWeight: "bold",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              color: "black",
                              fontFamily: "Poppins",
                              fontSize: "14px",
                              fontWeight: "500",
                            }}
                          >
                            {item["Account Type/Titled"]
                              ? item["Account Type/Titled"]
                              : "N/A"}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <div>
                          <p
                            style={{
                              fontFamily: "Poppins",
                              fontSize: "12px",
                              fontWeight: "400",
                              color: "#8B8D97",
                            }}
                          >
                            Type:
                          </p>
                        </div>
                        <div>
                          <p
                            style={{
                              fontWeight: "bold",
                              color: "black",
                              fontFamily: "Poppins",
                              fontSize: "14px",
                              fontWeight: "500",
                            }}
                          >
                            {item.type ? item.type : "N/A"}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div>
                        <p
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "12px",
                            fontWeight: "400",
                            color: "#8B8D97",
                          }}
                        >
                          SubType:
                        </p>
                      </div>
                      <div>
                        <p
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            //   paddingLeft: "0.4rem",
                            fontFamily: "Poppins",
                            fontSize: "14px",
                            fontWeight: "500",
                          }}
                        >
                          {item.subType ? item.subType : "N/A"}
                        </p>
                      </div>
                    </div>
                    <div style={{ display: "flex", width: "90%" }}></div>
                  </Style.Desc>
                  {/* <Style.Counts1>
                    <div style={{ width: "100%", display: "flex" }}>
                      <Style.Sign1>
                        <h3 style={{ color: "white", paddingTop: "0.5rem" }}>
                          $
                        </h3>
                      </Style.Sign1>
                      <div
                        style={{
                          width: "90%",
                          display: "flex",
                          justifyContent: "center",
                          paddingRight: "1rem",
                        }}>
                        <h3
                          style={{
                            paddingTop: "0.5rem",
                            color: "#39b54a",
                            fontWeight: "bold",
                          }}>
                          {moneyFormatter(item.total)}
                        </h3>
                      </div>
                    </div>
                  </Style.Counts1> */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      paddingInline: "1rem",
                    }}
                  >
                    <div>
                      <p
                        style={{
                          fontFamily: "Poppins",
                          fontSize: "12px",
                          fontWeight: "400",
                          color: "#8B8D97",
                        }}
                      >
                        Total:
                      </p>
                    </div>
                    <div>
                      <p
                        style={{
                          fontWeight: "bold",
                          color: "black",
                          // paddingLeft: "0.4rem",
                          fontFamily: "Poppins",
                          fontSize: "14px",
                          fontWeight: "500",
                        }}
                      >
                        {item.total ? moneyFormatter(item.total) : "$ 0"}
                      </p>
                    </div>
                  </div>
                </Style.Card>
              ))
            ) : (
              <h1>No Items to Display for this Asset Allocation.</h1>
            )}
          </Style.CardsMain>
        </Style.Cards>

        <div
          style={{
            display: "flex",
            width: "100%",
            padding: "1rem 1rem 0rem 1rem",
          }}
        >
          {activeItem && allHeading ? (
            <Style.SubCards
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Style.CardsHead>
                <h3 style={{ fontWeight: "bold", fontSize: "22px" }}>
                  Inventory Details
                </h3>
              </Style.CardsHead>
            </Style.SubCards>
          ) : null}
        </div>

        <div
          style={{
            display: "flex",
            width: "100%",
            padding: "1rem",
            columnGap: "2.3rem",
          }}
        >
          <Style.Rooms>
            {activeItem && allHeading ? (
              <Style.PropertyAdd
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  gap: "1rem",
                  width: "",
                }}
              >
                <div>
                  <h3 style={{ fontSize: "18px" }}>Add Room</h3>
                </div>
                <div
                  onClick={() => addRoom()}
                  className="upload"
                  style={{ width: "28px", height: "28px", cursor: "pointer" }}
                >
                  <img
                    src={addIcon}
                    width={12}
                    height={12}
                    style={{ width: "16px", height: "16px" }}
                    alt="addicon"
                  ></img>
                </div>
              </Style.PropertyAdd>
            ) : null}
            {allRooms &&
              allRooms.map((item, index) => (
                <Style.MainCard
                  key={index}
                  onClick={() => fetchItem(item)}
                  style={{
                    borderColor: activeRoom !== item.id ? colors.green : "none",
                  }}
                  active={item.id == activeRoom}
                >
                  <Style.CardImg>
                    <img
                      style={{
                        width: "100%",
                        // height: "10rem",
                      }}
                      src={item.img}
                    />
                  </Style.CardImg>
                  <Style.CardDetails
                    allowColumn={true}
                    style={{ flexWrap: "wrap-reverse" }}
                  >
                    <Style.CardDetailsColumn>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <Style.RoomCardP>Room:</Style.RoomCardP>
                        <p
                          style={{
                            margin: "0px",
                          }}
                        >
                          {item.room}
                        </p>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <Style.RoomCardP>Value: </Style.RoomCardP>
                        <p
                          style={{
                            margin: "0px",
                          }}
                        >
                          $
                          {item.value
                            ? `${item.value
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                            : "$0.00"}
                        </p>
                      </div>
                    </Style.CardDetailsColumn>
                    <Style.CardDetailsColumn>
                      <Style.CardItemsLarge
                        style={{
                          justifyContent: "space-between",
                          gap: "27px",
                        }}
                      >
                        <Style.CardItemsSmall
                          style={{ margin: "-5px 0px 1px 0px" }}
                        >
                          <Button
                            type="link"
                            style={{ fontSize: "16px" }}
                            icon="edit"
                            onClick={(e) => {
                              handleEditRoom(e, item);
                            }}
                          ></Button>

                          <Button
                            type="link"
                            onClick={(e) => {
                              handleViewRoom(e, item);
                            }}
                            style={{ fontSize: "16px" }}
                            icon="eye"
                          ></Button>

                          <Button
                            type="link"
                            style={{ fontSize: "16px" }}
                            icon="delete"
                            onClick={(e) => {
                              handleDelete(e, item, "room");
                            }}
                          ></Button>
                        </Style.CardItemsSmall>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <Style.RoomCardP>Property:</Style.RoomCardP>
                          <p style={{ marginBottom: "0px" }}>
                            {activeItem.name}
                          </p>
                        </div>
                      </Style.CardItemsLarge>
                    </Style.CardDetailsColumn>
                  </Style.CardDetails>
                </Style.MainCard>
              ))}
          </Style.Rooms>

          <div
            style={{
              display: "flex",
              width: "79%",
              flexDirection: "column",
              rowGap: "1rem",
            }}
          >
            {showItems ? (
              <React.Fragment>
                {/* <Style.PropertyAdd
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}>
                <div>
                  <h3>Add Item</h3>
                </div>
                <Style.AddBtn onClick={() => addItem(allItems)}>
                  {/* <h3 style={{ color: "white" }}>+</h3>
                   *
                  <img src={addIcon} />
                </Style.AddBtn>
              </Style.PropertyAdd> */}
                <Style.PropertyAdd
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gap: "1rem",
                    width: "",
                  }}
                >
                  <div>
                    <h3 style={{ fontSize: "18px" }}>Add Item</h3>
                  </div>
                  <div
                    onClick={() => addItem(allItems)}
                    className="upload"
                    style={{
                      width: "28px",
                      height: "28px",
                      cursor: "pointer",
                    }}
                  >
                    <img
                      src={addIcon}
                      width={12}
                      height={12}
                      style={{ width: "16px", height: "16px" }}
                      alt="addicon"
                    ></img>
                  </div>
                </Style.PropertyAdd>
              </React.Fragment>
            ) : null}
            {data === false ? (
              allItems &&
              allItems.map((item, index) => (
                <Style.MainCard
                  key={item.id}
                  style={{
                    borderColor: activeRoom !== item.id ? colors.green : "none",
                    display: "flex",
                    cursor: "default",
                  }}
                  active={item.id == activeRoom}
                >
                  <Style.CardImg>
                    <img
                      style={{
                        width: "100%",
                        height: "11rem",
                      }}
                      src={item.img}
                    />
                  </Style.CardImg>
                  <Style.CardDetails>
                    <Style.CardDetailsColumn>
                      <Style.CardItemsLarge>
                        <Style.RoomCardP>Name:</Style.RoomCardP>
                        <p
                        // style={{
                        //   alignSelf: "center",
                        // }}
                        >
                          {item.name}
                        </p>
                      </Style.CardItemsLarge>
                      <Style.CardItemsLarge>
                        <Style.RoomCardP>Quantity: </Style.RoomCardP>
                        <p
                        // style={{
                        //   alignSelf: "center",
                        //   paddingLeft: "5px",
                        // }}
                        >
                          {item.quantity}
                        </p>
                      </Style.CardItemsLarge>
                    </Style.CardDetailsColumn>
                    <Style.CardDetailsColumn>
                      <Style.CardItemsLarge>
                        <Style.RoomCardP>Current Value:</Style.RoomCardP>
                        <p
                        // style={{
                        //   alignSelf: "center",
                        // }}
                        >
                          $
                          {item.currentValue
                            ? `${item.currentValue
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                            : "$0.00"}
                        </p>
                      </Style.CardItemsLarge>
                      <Style.CardItemsLarge>
                        <Style.RoomCardP>Room: </Style.RoomCardP>
                        <p
                        // style={{
                        //   alignSelf: "center",
                        //   paddingLeft: "5px",
                        // }}
                        >
                          {item.room}
                        </p>
                      </Style.CardItemsLarge>
                    </Style.CardDetailsColumn>
                    <Style.CardDetailsColumn>
                      <Style.CardItemsLarge style={{ marginRight: "10px" }}>
                        <Style.RoomCardP>Property:</Style.RoomCardP>
                        <p
                        // style={{
                        //   alignSelf: "center",
                        // }}
                        >
                          {activeItem.name}
                        </p>
                      </Style.CardItemsLarge>
                      <Style.CardItemsLarge style={{ marginRight: "10px" }}>
                        <Style.RoomCardP>Total Value:</Style.RoomCardP>
                        <p
                        // style={{
                        //   alignSelf: "center",
                        // }}
                        >
                          $
                          {item.value
                            ? `${item.value
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                            : "$0.00"}
                        </p>
                      </Style.CardItemsLarge>
                    </Style.CardDetailsColumn>
                    <Style.CardDetailsColumn
                      style={{
                        flexBasis: "10%",
                        justifyContent: "space-around",
                      }}
                    >
                      <Style.CardItemsSmall
                        style={{
                          // flexDirection: "column",
                          // justifyContent: "space-evenly",
                          // paddingBottom: "10px",
                          margin: "0",
                          gap: "8px",
                        }}
                      >
                        <Button
                          type="link"
                          style={{ fontSize: "22px" }}
                          icon="edit"
                          onClick={(e) => {
                            handleEditItem(e, item);
                          }}
                        ></Button>
                        <Button
                          type="link"
                          style={{ fontSize: "22px" }}
                          icon="delete"
                          onClick={(e) => {
                            handleDelete(e, item);
                          }}
                        ></Button>
                        <Link
                          to={{
                            pathname: `/item-detail/${item.id}`,
                            query: `id=${item.id}`,
                            state: item,
                          }}
                        >
                          <Button
                            type="link"
                            style={{ fontSize: "22px" }}
                            icon="eye"
                          ></Button>
                        </Link>
                      </Style.CardItemsSmall>
                      {item.isLoan &&
                      <Style.CardItemsSmall style={{ gap: "8px" ,fontSize: "19px",
                        fontWeight: "bold",
                        color: "red",}}>
                      Loaned
                      </Style.CardItemsSmall>
                      }

                      <Style.CardItemsSmall style={{ gap: "8px" }}>
                        <Button
                          type="link"
                          style={{
                            fontSize: "16px",
                            backgroundColor: item.isLoan ? "#09A84D" : "#2a3da3",
                            color: colors.white,
                          }}
                          // icon="delete"
                          onClick={(e) => {
                            if(item.isLoan){
                              handleReturnItem(item.id)
                            }else{
                              setAddLoanModal(true);
                              setFormDataLoan({
                                ...formDataLoan,
                                ["itemId"]: item.id,
                              });
                            }
                          }}
                        >
                          {item.isLoan ? "Return" : "Loan" }
                        </Button>
                        <Button
                          type="link"
                          style={{
                            fontSize: "16px",
                            backgroundColor: "#2a3da3",
                            color: colors.white,
                          }}
                          // icon="delete"
                          onClick={(e) => {
                            setAddBorrowModal(true);
                            setFormDataBorrow({
                              ...formDataLoan,
                              ["itemId"]: item.id,
                            });
                          }}
                        >
                          Borrow
                        </Button>
                      </Style.CardItemsSmall>
                    </Style.CardDetailsColumn>
                  </Style.CardDetails>
                </Style.MainCard>
              ))
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <h1>NO ITEM FOUND</h1>
              </div>
            )}
          </div>
        </div>
      </Style.Main>
      <div>
        <Modal
          width={"58rem"}
          visible={isModal}
          footer={null}
          onCancel={handleModalCancel}
          style={{ width: showUpdateItem && "fit-content" }}
          bodyStyle={{ overflowY: "auto", maxHeight: "calc(100vh - 200px)" }}
        >
          {showPropertyAdd && (
            <PropertyAdd
              handleModalButton={handleModalButton}
              updateProperties={updateProperties}
            />
          )}
          {showRoomAdd && (
            <RoomAdd
              handleModalButton={handleModalButton}
              updateInventory={() => updateInventory(activeItem)}
              activeProperty={activeItem}
              parentId={parentId}
            />
          )}

          {showUpdateProperty && (
            <PropertyUpdate
              handleModalButton={handleModalButton}
              data={updateProperty}
              updateProperty={updateProperties}
            />
          )}
          {showUpdateRoom && (
            <RoomUpdate
              handleModalButton={handleModalButton}
              data={updateRoom}
              updateInventory={() => updateInventory(activeItem)}
              activeProperty={activeItem}
            />
          )}
          {/* {showUpdateItem && (
            <ItemUpdate
              data={updateItem}
              property={{ ...parentId, room: roomId }}
              isUpdate={true}
              editItem={editItemDetails}
            />
          )} */}
        </Modal>
        <Modal
          visible={detailsModal}
          footer={null}
          onOk={handleCancel}
          onCancel={handleCancel}
          closable={false}
          centered
        >
          <h3 className="modaltitle">
            Inventory {currentRecord && currentRecord.name} Details
          </h3>
          <div>
            <div
              className=""
              style={{ height: "18rem", maxHeight: "18rem", overflow: "auto" }}
            >
              {currentRecord && currentRecord.files.length > 0 ? (
                <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem" }}>
                  {currentRecord.name === "Images" &&
                    currentRecord.files.map((imgUrl, index) => (
                      <a
                        key={index}
                        href={imgUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={imgUrl}
                          alt={`Image ${index + 1}`}
                          style={{
                            width: "150px",
                            height: "150px",
                            objectFit: "cover",
                            borderRadius: "8px",
                          }}
                        />
                      </a>
                    ))}
                  {currentRecord.name === "Videos" &&
                    currentRecord.files.map((videoUrl, index) => {
                      const getVideoType = (url) => {
                        const ext = url.split(".").pop().toLowerCase();
                        const types = {
                          mp4: "video/mp4",
                          webm: "video/webm",
                          ogg: "video/ogg",
                          mov: "video/quicktime",
                        };
                        return types[ext] || "video/mp4";
                      };

                      return (
                        <div key={index} style={{ marginBottom: "1rem" }}>
                          <video
                            controls
                            width="200"
                            style={{ borderRadius: "8px", width: "100%" }}
                            onError={(e) => {
                              e.target.style.display = "none";
                              document.getElementById(
                                `fallback-${index}`
                              ).style.display = "block";
                            }}
                          >
                            <source
                              src={videoUrl}
                              type={getVideoType(videoUrl)}
                            />
                            Your browser does not support the video tag.
                          </video>
                          <div
                            id={`fallback-${index}`}
                            style={{ display: "none", color: "red" }}
                          >
                            <p>⚠️ Video format not supported. </p>
                            <button
                              onClick={async () => {
                                try {
                                  const response = await fetch(videoUrl);
                                  const blob = await response.blob();
                                  const blobUrl =
                                    window.URL.createObjectURL(blob);
                                  const a = document.createElement("a");
                                  a.href = blobUrl;
                                  a.download = `video-${index}`; // You can customize the filename
                                  document.body.appendChild(a);
                                  a.click();
                                  document.body.removeChild(a);
                                  window.URL.revokeObjectURL(blobUrl);
                                } catch (error) {
                                  alert("Failed to download video.");
                                  console.error("Download error:", error);
                                }
                              }}
                              style={{
                                color: "#2a3da3",
                                textDecoration: "underline",
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                              }}
                            >
                              Download Video
                            </button>
                          </div>
                        </div>
                      );
                    })}
                </div>
              ) : (
                <h3 className="inputTitle">No Data to Show</h3>
              )}
            </div>
          </div>

          <div className="buttonsMain" style={{ justifyContent: "center" }}>
            <button
              className="savebutton"
              onClick={() => {
                handleCancel();
              }}
            >
              Close
            </button>
          </div>
        </Modal>
      </div>
      {addLoanModal && (
        <LoanItemModal
          title={"Add Loan"}
          open={addLoanModal}
          handleChange={handleInputChangeLoan}
          handleCancel={handleCancelAddLoanModal}
          data={formDataLoan && formDataLoan}
          handleSave={handleSaveAddLoanModal}
        />
      )}
      {addBorrowModal && (
        <BorrowItemModal
          title={"Add Borrow"}
          open={addBorrowModal}
          handleChange={handleInputChangeBorrow}
          handleCancel={handleCancelAddBorrowModal}
          data={formDataBorrow && formDataBorrow}
          handleSave={handleSaveAddBorrowModal}
        />
      )}
      <Loader isLoading={isLoading} />
    </div>
  );
}

export default inventory;
